import React from 'react';
import { joinClass } from '../helpers/component';

const CardGroup = ({
  children,
  className,
  svg: SvgIcon,
}) => {
  const makeItem = (child, index) => child && (
    <>
      <div className="compare-block__item" key={index}>
        {child}
      </div>
      {index === 0 && SvgIcon && <SvgIcon className="compare-block__svg" />}
    </>
  );

  return (
    <div className={joinClass('compare-block', className)}>
      {Array.isArray(children)
        && children.map((child, index) => makeItem(child, index))}
      {!Array.isArray(children) && makeItem(children)}
    </div>
  );
};

export default CardGroup;
